(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('portfolio-gallery')) {
    class PortfolioGallery extends HTMLElement {
      constructor() {
        super();

        this.expandedCard = null;
        this.lastFocusedElement = null;

        this.boundOnClick = this.onClick.bind(this);
        this.boundOnKeydown = this.onKeydown.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.boundOnClick);
        this.addEventListener('keydown', this.boundOnKeydown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.boundOnClick);
        this.removeEventListener('keydown', this.boundOnKeydown);
        this.collapseCard();
      }

      get expansionEnabled() {
        return this.dataset.galleryExpand === 'true';
      }

      onClick(event) {
        if (event.target.closest('a')) return;

        if (event.target.closest('[data-gallery-backdrop], [data-gallery-close]')) {
          this.collapseCard();
          return;
        }

        if (!this.expansionEnabled) return;

        const trigger = event.target.closest('[data-gallery-expand-trigger]');
        if (!trigger || !this.contains(trigger)) return;

        const card = trigger.closest('.gl-portfolio-gallery__card, .gl-portfolio-gallery__reel-card');
        if (!card) return;

        if (card === this.expandedCard) {
          this.collapseCard();
          return;
        }

        this.expandCard(card);
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.expandedCard) {
          this.collapseCard();
        }
      }

      expandCard(card) {
        if (this.expandedCard) {
          this.expandedCard.classList.remove('is-expanded');
          this.expandedCard.setAttribute('aria-expanded', 'false');
        }

        this.lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        this.expandedCard = card;
        this.classList.add('is-expanded');
        card.classList.add('is-expanded');
        card.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('gl-portfolio-gallery-expanded');
      }

      collapseCard() {
        if (!this.expandedCard) return;

        this.expandedCard.classList.remove('is-expanded');
        this.expandedCard.setAttribute('aria-expanded', 'false');
        this.expandedCard = null;
        this.classList.remove('is-expanded');
        document.documentElement.classList.remove('gl-portfolio-gallery-expanded');

        if (this.lastFocusedElement && this.contains(this.lastFocusedElement)) {
          this.lastFocusedElement.focus({ preventScroll: true });
        }

        this.lastFocusedElement = null;
      }
    }

    customElements.define('portfolio-gallery', PortfolioGallery);
  }

  } catch(e) { console.error(e); }
})();
})();
